export default __webpack_public_path__ + "static/media/screenshot_app_pathways_desktop_purple.03021e9b.png";